import { render } from "./ReviewMediaModal.vue?vue&type=template&id=35f33fd0&scoped=true"
import script from "./ReviewMediaModal.vue?vue&type=script&lang=js"
export * from "./ReviewMediaModal.vue?vue&type=script&lang=js"

import "./ReviewMediaModal.vue?vue&type=style&index=0&id=35f33fd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f33fd0"]])

export default __exports__